import { Box, Grid } from '@mui/material';

import LoginForm from '@pages/common/Login/LoginForm';
import backgroundImage from '@assets/register-bg.jpeg';
import {
  LoginBanner,
  LoginContainer,
} from '@pages/common/Login/StyledComponents';
import ThemeModeToggle from '@components/ThemeModeToggle';

const Login = () => (
  <LoginContainer container sx={{ position: 'relative' }}>
    <Box sx={{ position: 'fixed', top: 16, right: 16, zIndex: 1 }}>
      <ThemeModeToggle />
    </Box>
    <Grid item xs={0} sm={0} md={7}>
      <LoginBanner sx={{ backgroundImage: `url("${backgroundImage}")` }} />
    </Grid>
    <Grid item xs={12} sm={12} md={5} sx={{ p: { xs: 2, sm: 4, md: 5 } }}>
      <Box sx={{ width: '100%', maxWidth: 460, mx: 'auto' }}>
        <LoginForm />
      </Box>
    </Grid>
  </LoginContainer>
);

export default Login;
